"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToolTip = void 0;
exports.addToolTip = function () {
    var shareButton = document.querySelector('[aria-label="Link"]');
    if (!shareButton)
        return;
    var tooltip = document.createElement('div');
    tooltip.classList.add('jw-reset', 'jw-tooltip', 'jw-open');
    tooltip.innerHTML = '<div class="jw-text">Gekopieerd!</div></div>';
    shareButton.appendChild(tooltip);
    setTimeout(function () {
        tooltip.remove();
    }, 1000);
};
